import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../../UIAssetKeys';
import Forces from '../../common/Forces';

export default class WhippedSpraySprite extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._particle_whipped_cream_4);

    this.fade = false;

    this.mass = 1.0;
    this.gravity = 0;
    this.k = 0.0;

    this.pos = null;
    this.vel = null;
    this.lifetime = 2;
    this.age = 0;
    this.halflife = 0;

    this.gravityForce = null;
    this.totalForce = null;

    this.gravityForce = new Phaser.Math.Vector2();
    this.dragForce = new Phaser.Math.Vector2();
    this.totalForce = new Phaser.Math.Vector2();
    Forces.constantGravity(this.mass, this.gravity, this.gravityForce);
    this.pos = new Phaser.Math.Vector2();
    this.vel = new Phaser.Math.Vector2();

    this.isValid = true;

    this.landRect = {};
    this.landRect.left = 0;
    this.landRect.right = 0;
    this.landRect.width = 0;
    this.landRect.bottom = 0;
    this.landRect.top = 0;
    this.landRect.height = 0;
    this.landRect.y = 0;
    this.landRect.x = 0;
  }

  move (dt) {
    this.pos.add({ x: this.vel.x * dt,y: this.vel.y * dt });
    this.angle += this.vel.x * dt;
  }

  updateAccel () {
    this.totalForce.multiply({ x: 1 / this.mass, y: 1 / this.mass });
  }

  updateVelocity (dt) {
    this.vel.add({ x: this.totalForce.x * dt, y: this.totalForce.y * dt });
  }

  update () {
    this.x = this.pos.x;
    this.y = this.pos.y;
    this.screenRect = { x: this.pos.x - this.width / 4, y: this.pos.y - this.height / 4, width: this.width / 2, height: this.height / 2 };
  }

  clone() {
    const clone = new WhippedSpraySprite(this.scene);
    clone.setPosition(this.x, this.y);
    clone.pos.x = this.pos.x;
    clone.pos.y = this.pos.y;
    clone.vel.x = this.vel.x;
    clone.vel.y = this.vel.y;
    clone.lifetime = this.lifetime;
    clone.halflife = this.halflife;
    clone.age = this.age;
    clone.alpha = this.alpha;
    clone.angle = Phaser.Math.Between(0,359);
    clone.setFrame(this.frame.name).setOrigin(0.5);
    clone.yLimit = this.yLimit;

    return clone;
  }

  reset (x,y,vx,vy,lifetime, toppingId, yLimit) {
    this.isValid = true;
    this.pos.x = x;
    this.pos.y = y;
    this.vel.x = vx;
    this.vel.y = vy;
    this.lifetime = lifetime;
    this.halflife = lifetime / 2;
    this.age = 0;
    this.alpha = 1;
    this.angle = Phaser.Math.Between(0,359);
    this.setFrame(`particle_whipped_cream+${toppingId}`).setOrigin(0.5);
    this.yLimit = yLimit;

    this.update();
  }

  tick (dt) {
    this.move(dt);
    this.angle += 200 * dt;

    this.updateAccel();
    this.updateVelocity(dt);

    this.age += dt;

    if (this.fade && this.age > this.halflife) {
      this.alpha -= 0.8 * dt;
    }

    return this.pos.y < this.yLimit;
  }
}